import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-2xl text-white mb-3">{title}</h2>
    <div className="text-slate-300 leading-relaxed text-sm space-y-3">{children}</div>
  </section>
);

const Privacy = () => (
  <div data-testid="legal-privacy-page" className="pt-28 pb-24 max-w-3xl mx-auto px-6 sm:px-12">
    <div className="text-xs uppercase tracking-[0.3em] text-fuchsia-300 mb-3">Legal</div>
    <h1 className="font-display text-4xl font-bold text-white tracking-tight mb-2">Privacy Policy</h1>
    <p className="text-slate-500 text-xs mb-10">Last updated: February 13, 2026</p>

    <Section title="1. Who we are">
      <p>Maarivil (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) is an AI-powered talent marketplace connecting artists, event organizers, casting directors and fans across India and the world. This Policy explains what personal data we collect, why, and how we protect it.</p>
    </Section>

    <Section title="2. Information we collect">
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Account data:</strong> name, email, password hash, role, profile picture.</li>
        <li><strong>Artist profile:</strong> stage name, bio, skills, languages, pricing, portfolio media, social links you choose to share, milestones and gallery you upload.</li>
        <li><strong>Bookings &amp; transactions:</strong> event details, messages, payment metadata (we do not store full card numbers — handled by Stripe).</li>
        <li><strong>KYC documents:</strong> ID + selfie (encrypted at rest, only accessed by approved admins).</li>
        <li><strong>Device &amp; usage:</strong> IP, browser, pages viewed, AI search prompts (used to improve relevance).</li>
        <li><strong>Cookies:</strong> a single httpOnly session cookie for authentication and a theme preference cookie.</li>
      </ul>
    </Section>

    <Section title="3. How we use your information">
      <ul className="list-disc pl-5 space-y-1">
        <li>To create and operate your account, profile and bookings.</li>
        <li>To run AI-powered talent discovery (we send anonymized prompts to Claude / Anthropic via Emergent).</li>
        <li>To process payments and prevent fraud via Stripe.</li>
        <li>To verify identity via KYC submissions.</li>
        <li>To send transactional emails (booking updates, KYC outcomes, payment receipts).</li>
        <li>To improve the platform and detect abuse.</li>
      </ul>
    </Section>

    <Section title="4. Sharing">
      <p>We share only the minimum necessary data with: Stripe (payments), Emergent / Anthropic (AI), MongoDB Atlas (storage), and law-enforcement when legally compelled. We never sell your personal data.</p>
    </Section>

    <Section title="5. Your rights">
      <p>You can request a copy of your data, correct it, or delete your account by emailing <a className="text-fuchsia-300" href="mailto:support@maarivil.com">support@maarivil.com</a>. Verified KYC documents are retained for 90 days after account deletion to comply with anti-fraud obligations.</p>
    </Section>

    <Section title="6. Children">
      <p>Maarivil is not intended for users under 16. If you believe a minor has registered, contact us and we will promptly remove the account.</p>
    </Section>

    <Section title="7. Security">
      <p>Passwords are hashed with bcrypt, traffic is encrypted in transit (TLS), and admin actions are logged. Despite our safeguards, no system is 100% secure.</p>
    </Section>

    <Section title="8. Updates">
      <p>We may revise this policy. Material changes will be highlighted on this page and emailed to active accounts.</p>
    </Section>

    <p className="text-xs text-slate-500 mt-8">Questions? Reach us at <a className="text-fuchsia-300" href="mailto:support@maarivil.com">support@maarivil.com</a>.</p>
  </div>
);

export default Privacy;
